import { render, staticRenderFns } from "./BtnExcluirAnexoParcelamento.vue?vue&type=template&id=07fca55b&"
import script from "./BtnExcluirAnexoParcelamento.vue?vue&type=script&lang=js&"
export * from "./BtnExcluirAnexoParcelamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports